// Re-export shared constants from centralized module
export {
  CIRCLE_OPTIONS,
  DIAMOND_OPTIONS,
  ELEMENT_TYPE,
  EXPORT_FORMAT_OPTIONS,
  EXTRA_LOCAL_FONTS,
  FABRIC_CUSTOM_PROPS,
  FILL_COLOR,
  filters,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  fonts,
  GROUP_ALIGNMENT_OPTIONS,
  GROUP_OPTIONS,
  JSON_KEYS,
  PLAYER_NAME_REGEX,
  POSITION_TOOL_OPTIONS,
  RECTANGLE_OPTIONS,
  selectionDependentTools,
  STROKE_COLOR,
  STROKE_DASH_ARRAY,
  STROKE_WIDTH,
  TEMPLATE_PAYLOAD,
  TEXT_FONT_WEIGHT_OPTIONS,
  TEXT_OPTIONS,
  TEXTCASE_TOOL_OPTIONS,
  TRIANGLE_OPTIONS,
} from "./thumbnailEditor/shared";

// Re-export graphics-specific constants
export {
  GAME_GROUP_SPACING,
  GRAPHICS_ALLOWED_MOVEMENT_PAYLOAD_TYPES,
  GRAPHICS_ALLOWED_PREVIEW_IMAGE_PAYLOAD_TYPES,
  GRAPHICS_NOT_ALLOWED_PAYLOAD_TYPES,
  GRAPHICS_TEMPLATE_KEY_ORDER,
  GRAPHICS_TEMPLATE_PLAYER_NAME_NAMETYPE_KEYS,
  MAX_GAME_COUNT,
} from "./graphics";

// Thumbnail editor specific constants
export const THUMBNAIL_ASPECT_RATIOS = [
  {
    label: "16:9",
    value: "16:9",
  },
  {
    label: "9:16",
    value: "9:16",
  },
  {
    label: "9:18",
    value: "9:18",
  },
  {
    label: "3:4",
    value: "3:4",
  },
  // { label: "4:3", value: "4:3" },
  {
    label: "4:5",
    value: "4:5",
  },
  {
    label: "1:1",
    value: "1:1",
  },
];

export const THUMBNAIL_ASPECT_RATIO_DIMENSIONS = {
  "16:9": {
    width: 1280,
    height: 720,
  },
  "9:16": {
    width: 1080,
    height: 1920,
  },
  "9:18": {
    width: 1080,
    height: 2160,
  },
  "3:4": {
    width: 1080,
    height: 1440,
  },
  "4:3": {
    width: 1200,
    height: 900,
  },
  "4:5": {
    width: 1080,
    height: 1350,
  },
  "1:1": {
    width: 1080,
    height: 1080,
  },
};

export const TEMPLATE_IMAGE_OPTIONS = {
  tournament_logo: [
    {
      value: "tournament_logo",
      label: "Tournament Logo",
    },
  ],
  sponsor_logo: [
    {
      value: "sponsor_logo",
      label: "Sponsor Logo",
    },
  ],
  broadcaster_logo: [
    {
      value: "broadcaster_logo",
      label: "Broadcaster Logo",
    },
  ],
  team_logo: [
    {
      value: "team_1_logo",
      label: "Team 1 Logo",
    },
    {
      value: "team_2_logo",
      label: "Team 2 Logo",
    },
  ],
  team_shot: [
    {
      value: "team_1_full_image",
      label: "Team 1 Shot",
    },
    {
      value: "team_2_full_image",
      label: "Team 2 Shot",
    },
  ],
  coach_image: [
    {
      value: "team_1_coach_image",
      label: "Team 1 Coach",
    },
    {
      value: "team_2_coach_image",
      label: "Team 2 Coach",
    },
  ],
  country_flag: [
    {
      value: "player_1_country_flag",
      label: "Player 1 Country Flag",
    },
    {
      value: "player_2_country_flag",
      label: "Player 2 Country Flag",
    },
    {
      value: "player_3_country_flag",
      label: "Player 3 Country Flag",
    },
    {
      value: "player_4_country_flag",
      label: "Player 4 Country Flag",
    },
  ],
  custom_image: [
    {
      value: "custom_image",
      label: "Custom Image",
    },
  ],
  player_full_shot: [
    {
      value: "player_1_full_shot",
      label: "Player 1 Full Shot",
    },
    {
      value: "player_2_full_shot",
      label: "Player 2 Full Shot",
    },
    {
      value: "player_3_full_shot",
      label: "Player 3 Full Shot",
    },
    {
      value: "player_4_full_shot",
      label: "Player 4 Full Shot",
    },
  ],
  player_half_shot: [
    {
      value: "player_1_half_shot",
      label: "Player 1 Half Shot",
    },
    {
      value: "player_2_half_shot",
      label: "Player 2 Half Shot",
    },
    {
      value: "player_3_half_shot",
      label: "Player 3 Half Shot",
    },
    {
      value: "player_4_half_shot",
      label: "Player 4 Half Shot",
    },
  ],
  capture_image: [
    {
      value: "capture_image",
      label: "Capture Image",
    },
  ],
  background_image: [
    {
      value: "background_image",
      label: "Background Image",
    },
  ],
};

export const TOURNAMENT_KEYS = ["tournament_logo", "sponsor_logo", "broadcaster_logo"];

export const TEAM_KEYS = [
  ...TEMPLATE_IMAGE_OPTIONS.team_logo.map((option) => option.value),
  ...TEMPLATE_IMAGE_OPTIONS.team_shot.map((option) => option.value),
  ...TEMPLATE_IMAGE_OPTIONS.coach_image.map((option) => option.value),
];

export const PLAYER_KEYS = [
  ...TEMPLATE_IMAGE_OPTIONS.player_full_shot.map((option) => option.value),
  ...TEMPLATE_IMAGE_OPTIONS.player_half_shot.map((option) => option.value),
];

export const LOGO_OPTIONS = [
  {
    value: "team_logo",
    name: "Team Logo",
    image: "https://d38fyt9cg02csl.cloudfront.net/thumbnail-templates/placeholders/team_logo.png",
  },
  {
    value: "tournament_logo",
    name: "Tournament",
    image: "https://d38fyt9cg02csl.cloudfront.net/thumbnail-templates/placeholders/tournament.png",
  },
  {
    value: "sponsor_logo",
    name: "Sponsor",
    image: "https://d38fyt9cg02csl.cloudfront.net/thumbnail-templates/placeholders/sponsor.png",
  },
  {
    value: "broadcaster_logo",
    name: "Broadcaster",
    image: "https://d38fyt9cg02csl.cloudfront.net/thumbnail-templates/placeholders/broadcaster.png",
  },
  {
    value: "country_flag",
    name: "Country Flag",
    image: "https://d38fyt9cg02csl.cloudfront.net/thumbnail-templates/placeholders/country_flag.png",
  },
];

export const IMAGE_OPTIONS = [
  {
    value: "team_shot",
    name: "Team Shot",
    image: "https://d38fyt9cg02csl.cloudfront.net/thumbnail-templates/placeholders/team_shot.svg",
  },
  {
    value: "player_full_shot",
    name: "Player Full Shot",
    image: "https://d38fyt9cg02csl.cloudfront.net/thumbnail-templates/placeholders/player_full_shot.png",
  },
  {
    value: "player_half_shot",
    name: "Player Half Shot",
    image: "https://d38fyt9cg02csl.cloudfront.net/thumbnail-templates/placeholders/player_half_shot.png",
  },
  {
    value: "coach_image",
    name: "Coach",
    image: "https://d38fyt9cg02csl.cloudfront.net/thumbnail-templates/placeholders/coach_image.png",
  },
];

export const CUSTOM_IMAGE_OPTIONS = [
  {
    value: "background_image",
    name: "Background",
    image: "https://d38fyt9cg02csl.cloudfront.net/thumbnail-templates/placeholders/background_image.svg",
  },
];

export const THUMBNAIL_TEMPLATE_PLAYER_NAMES = ["player_1_name", "player_2_name", "player_3_name", "player_4_name"];

export const THUMBNAIL_TEMPLATE_PLAYER_NAME_OPTIONS = [
  {
    value: "full_name",
    label: "Full Name",
  },
  {
    value: "first_name",
    label: "First Name",
  },
  {
    value: "last_name",
    label: "Last Name",
  },
  {
    value: "middle_name",
    label: "Middle Name",
  },
];

export const STATS_KEY_OPTIONS = [
  {
    value: "PTS",
    label: "PTS",
  },
  {
    value: "REB",
    label: "REB",
  },
  {
    value: "AST",
    label: "AST",
  },
  {
    value: "STL",
    label: "STL",
  },
  {
    value: "BLK",
    label: "BLK",
  },
  {
    value: "FGM",
    label: "FGM",
  },
  {
    value: "FGA",
    label: "FGA",
  },
  {
    value: "FTM",
    label: "FTM",
  },
  {
    value: "FTA",
    label: "FTA",
  },
  {
    value: "EFF",
    label: "EFF",
  },
  {
    value: "FG%",
    label: "FG%",
  },
  {
    value: "FT%",
    label: "FT%",
  },
  {
    value: "3PA",
    label: "3PA",
  },
  {
    value: "3PM",
    label: "3PM",
  },
  {
    value: "3P%",
    label: "3P%",
  },
];

export const STATS_KEY_TO_DF_KEY_MAP = {
  PTS: "sPoints",
  REB: "sReboundsTotal",
  AST: "sAssists",
  STL: "sSteals",
  BLK: "sBlocks",
  FGM: "sFieldGoalsMade",
  FGA: "sFieldGoalsAttempted",
  FTM: "sFreeThrowsMade",
  FTA: "sFreeThrowsAttempted",
  EFF: "sEfficiency",
  "FG%": "sFieldGoalsPercentage",
  "FT%": "sFreeThrowsPercentage",
  "3PA": "sThreePointersAttempted",
  "3PM": "sThreePointersMade",
  "3P%": "sThreePointersPercentage",
};
